export default __webpack_public_path__ + "static/media/folder-open-icon.b1af93e5.svg";